unit f_scrivikm;

{$mode objfpc}

interface

uses
  Classes, SysUtils, js, web, un_widget, un_tquery, w_table, un_generator, f_selezione, un_user;

type

  { TFrmScriviKm }

  TFrmScriviKm = class(TWidget)
    nuovorecord :String;
    procedure AfterRender; override;
    procedure AfterDomAppend; async; override;
    idtrasporto:integer;
    procedure salva_click(Event: TJSEvent); async;
    procedure chiudi_click(Event: TJSEvent); async;

  private

  published
    procedure CompilaCampi; async;
    procedure ControlloCompilazioneCampi; async;
    QryScriviKm: TQuery;
    iddata: TJSHTMLSelectElement;
    idora: TJSHTMLSelectElement;
    idviaggio: TJSHTMLSelectElement;
    idannullato: TJSHTMLSelectElement;
    dtscadenza: TJSHTMLSelectElement;
    idkmarrivo: TJSHTMLSelectElement;
    idkmpartenza: TJSHTMLSelectElement;
    idutente: TJSHTMLSelectElement;

  end;

implementation

{$R *.html}

{ TFrmScriviKm }

procedure TFrmScriviKm.AfterRender;
begin

//

end;

procedure TFrmScriviKm.AfterDomAppend;
begin

  Await(CompilaCampi);

end;

procedure TFrmScriviKm.salva_click(Event: TJSEvent);
var
  idAutomezzo: Integer;
  dtData: String;
  oraPartenza: String;
  kmArrivo: String;
  dtDataSQL: String;
begin

  try

    // Recupero i dati del record corrente
    idAutomezzo := QryScriviKm.FieldByName('idautomezzo').AsInteger;
    dtData := QryScriviKm.FieldByName('dtdata').AsString;
    oraPartenza := QryScriviKm.FieldByName('horapartenza').AsString;

    // Recupero i km arrivo appena inseriti
    kmArrivo := Trim(idkmarrivo.value);

    // Salvo il record corrente
    QryScriviKm.edit;

    QryScriviKm.FieldByName('idkmarrivo').AsString := kmArrivo;
    QryScriviKm.FieldByName('dsstato').AsString := idannullato.value;
    QryScriviKm.FieldByName('idutentekm').AsInteger := StrToInt(idutente.value);

    QryScriviKm.Post;
    QryScriviKm.ApplyUpdates;

    // Se data, ora o km arrivo non sono valorizzati,
    // non aggiorno il record successivo
    if (Trim(dtData) <> '') and
       (Trim(oraPartenza) <> '') and
       (Trim(kmArrivo) <> '') then
    begin

      // Converto la data nel formato SQL Firebird YYYY-MM-DD
      // La data proveniente dal campo può essere DD/MM/YYYY
      dtDataSQL :=
        Copy(dtData, 7, 4) + '-' +
        Copy(dtData, 4, 2) + '-' +
        Copy(dtData, 1, 2);

      // Aggiorno il record immediatamente successivo
      // dello stesso automezzo.
      //
      // Il successivo viene determinato in ordine:
      // DTDATA
      // HORAPARTENZA
      // IDTRASPORTO
      //
      // Nel record trovato scrivo IDKMARRIVO
      // del record appena salvato come IDKMPARTENZA.

      QryScriviKm.SQL.Text :=
          'UPDATE TA_TRASPORTI '
        + 'SET IDKMPARTENZA = ' + kmArrivo + ' '
        + 'WHERE IDTRASPORTO = ( '
        + '  SELECT FIRST 1 IDTRASPORTO '
        + '  FROM TA_TRASPORTI '
        + '  WHERE IDAUTOMEZZO = ' + IntToStr(idAutomezzo)
        + '    AND ( '
        + '      DTDATA > DATE ' + QuotedStr(dtDataSQL)
        + '      OR '
        + '      (DTDATA = DATE ' + QuotedStr(dtDataSQL)
        + '       AND HORAPARTENZA > ' + QuotedStr(oraPartenza) + ')'
        + '      OR '
        + '      (DTDATA = DATE ' + QuotedStr(dtDataSQL)
        + '       AND HORAPARTENZA = ' + QuotedStr(oraPartenza)
        + '       AND IDTRASPORTO > ' + IntToStr(idtrasporto) + ')'
        + '    ) '
        + '  ORDER BY DTDATA ASC, HORAPARTENZA ASC, IDTRASPORTO ASC '
        + ')';

      await(QryScriviKm.ExecuteSql);

    end;

    ShowMessage('Modifica eseguita con successo...');

    Close();

  except
    on E: Exception do
    begin
      ShowMessage(
        'Errore Database: ' +
        E.Message
      );
    end;
  end;

end;

procedure TFrmScriviKm.chiudi_click(Event: TJSEvent);
begin

  Close;

end;

procedure TFrmScriviKm.CompilaCampi;
begin

  console.log('idKM = ' + IntToStr(IDTRASPORTO));

  QryScriviKm.Close;
  QryScriviKm.SQL.Text:= ' SELECT idtrasporto, dtdata, horapartenza, idautomezzo, dsautomezzo, dsfruitore, '
                        + ' dstiporichiesta, idkmpartenza, idkmarrivo, dsstato, idutentekm '
                        + ' from ta_trasporti  '
                        + ' where idtrasporto = ' + IntToStr(idtrasporto);
  AWait(QryScriviKm.Open);


  iddata.value := QryScriviKm.FieldByName('dtdata').AsString;
  idora.value := QryScriviKm.FieldByName('horapartenza').AsString;
  idviaggio.value := 'tipo  richiesta: ' + QryScriviKm.FieldByName('dstiporichiesta').AsString
    + ' - destinazione: ' + QryScriviKm.FieldByName('dsfruitore').AsString
    + ' - mezzo: '  + QryScriviKm.FieldByName('dsautomezzo').AsString;
  idkmpartenza.value := QryScriviKm.FieldByName('idkmpartenza').AsString;
  idkmarrivo.value := QryScriviKm.FieldByName('idkmarrivo').AsString;
  idannullato.value := QryScriviKm.FieldByName('dsstato').AsString;
  idutente.value := user.QryUtenti.FieldByName('iduser').AsString;

end;

procedure TFrmScriviKm.ControlloCompilazioneCampi;
begin
  // controllo se i campi sono compilati
    //if idkmarrivo.value = '' then
    //  begin
    //    ShowMessage('Devi inserire i km.');
    //    Exit;
    //  end;
end;

initialization
  RegisterWeb(TFrmScriviKm);

end.

